import React from 'react';
import { Link } from '@thd-olt-component-react/router';
import { Button } from '@one-thd/sui-atomic-components';
import { clickEvents } from '../../../utils/analytics';
import { EXP_ROUTES } from '../../../utils/constants';
import { composeGoBackUrlParam } from '../../../utils/go-back';

const ProfileShowMoreButton = ({ item }) => {

  const sendShowMoreClickEvent = () => {
    clickEvents.recommendationsTabActionsClick('show');
  };

  return (
    <div
      className="ptp-search-grid-item__show-more"
      tabIndex={-1}
    >
      <Link
        to={EXP_ROUTES.SEARCH_PROFILE(item.candidateId) + composeGoBackUrlParam()}
        className="slm__link-no-underline"
        onClick={sendShowMoreClickEvent}
        data-testid="profile-show-more-btn"
      >
        <Button
          onClick={sendShowMoreClickEvent}
          variant="secondary"
          size="large"
        >View Profile
        </Button>
      </Link>
    </div>
  );
};

export default ProfileShowMoreButton;
